import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export const PrivateRoute = (props) => {
  const logged = sessionStorage.getItem('tokenMc');

  if (!logged) {
    return <Navigate to="/auth/login" />;
  }
  return <Outlet />;
};
